import { Injectable } from '@angular/core';
import { UserRoles } from '../../../enums/user-roles.enum';

@Injectable({
  providedIn: 'root',
})
export class UserProfilePermissionUtils {
  canSeeOwnProfile(role: UserRoles | undefined) {
    // NOT INCLUDED: NONE
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUP_COORDINATOR ||
      role === UserRoles.GROUPADMIN ||
      role === UserRoles.GROUPMANAGER ||
      role === UserRoles.GROUP ||
      role === UserRoles.LOCMGR ||
      role === UserRoles.USER
    );
  }

  canAddUsers(role: string): boolean {
    // NOT INCLUDED: GROUPMANAGER, GROUP, USER, LOCMGR
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUP_COORDINATOR ||
      role === UserRoles.GROUPADMIN
    );
  }

  canEditUsers(role: string) {
    // NOT INCLUDED: USER, LOCMGR
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUP_COORDINATOR ||
      role === UserRoles.GROUPADMIN ||
      role === UserRoles.GROUPMANAGER ||
      role === UserRoles.GROUP
    );
  }

  canDeleteUsers(role: string) {
    // NOT INCLUDED: GROUPMANAGER, GROUP, USER, LOCMGR
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUP_COORDINATOR ||
      role === UserRoles.GROUPADMIN
    );
  }

  canEditUserLocation(role: UserRoles | undefined) {
    // NOT INCLUDED: USER, LOCMGR
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUP_COORDINATOR ||
      role === UserRoles.GROUPADMIN ||
      role === UserRoles.GROUPMANAGER ||
      role === UserRoles.GROUP
    );
  }

  canEditUserLocationGroup(role: UserRoles | undefined) {
    // NOT INCLUDED: GROUPMANAGER, GROUP, USER, LOCMGR
    return (
      role === UserRoles.ADMIN ||
      role === UserRoles.GROUP_COORDINATOR ||
      role === UserRoles.GROUPADMIN
    );
  }
}
